import { useQuery } from "@tanstack/react-query"

import { getAffiliateCategories } from "@/api"

export const useAffiliateCategories = () => {
  return useQuery({
    queryKey: ["categories"],
    queryFn: () => getAffiliateCategories(),
    gcTime: 10000
  })
}